






















































































































































































































import { Component, Vue } from "vue-property-decorator";
import ia_agent_item from "./ia_agent_item.vue";
import ia_agent_editor from "./ia_agent_editor.vue";
import HttpAgentEditorDialog from "@/components/marketplace/HttpAgentEditorDialog.vue";
import ia_agent_type_selector from "@/components/marketplace/ia_agent_type_selector.vue";
import { ia_agents_store, ia_agent } from "@/shared/classes/ia_agents_store";
import { RouterNames } from "@/router/routernames";

@Component({
  components: { ia_agent_item, ia_agent_editor,HttpAgentEditorDialog, ia_agent_type_selector},
})
export default class ia_marketplace_panel extends Vue {
  public tab: number = 0;
  public agents: ia_agent[] = [];

  public qMine: string = "";
  public qPub: string = "";
  public catMine: string = "Todas";
  public catPub: string = "Todas";

  public editing: boolean = false;
  public current: ia_agent | null = null;

  public showConfirmDelete: boolean = false;
  public toDelete: ia_agent | null = null;

  public mounted(): void {
    this.syncFromStore();
  }

  private syncFromStore(): void {
    this.agents = ia_agents_store.list();
  }

  // categorías dinámicas
  get categoriesMine(): string[] {
    const set: { [k: string]: boolean } = {};
    const mine = this.agents;
    for (let i = 0; i < mine.length; i++) {
      const c = mine[i].category || "";
      if (c.trim().length > 0) set[c] = true;
    }
    const arr = Object.keys(set);
    arr.sort();
    arr.unshift("Todas");
    return arr;
  }

  get categoriesPub(): string[] {
    const set: { [k: string]: boolean } = {};
    const pub = this.agents.filter(function(a) {
      return a.isPublic;
    });
    for (let i = 0; i < pub.length; i++) {
      const c = pub[i].category || "";
      if (c.trim().length > 0) set[c] = true;
    }
    const arr = Object.keys(set);
    arr.sort();
    arr.unshift("Todas");
    return arr;
  }

  // filtros
  get filteredMine(): ia_agent[] {
    const q = (this.qMine || "").toLowerCase();
    const cat = this.catMine || "Todas";
    return this.agents.filter(function(a) {
      const okCat = cat === "Todas" ? true : (a.category || "") === cat;
      const text = (
        a.name +
        " " +
        a.description +
        " " +
        a.tags.join(" ")
      ).toLowerCase();
      const okQ = q.length === 0 ? true : text.indexOf(q) !== -1;
      return okCat && okQ;
    });
  }

  get filteredPublic(): ia_agent[] {
    const q = (this.qPub || "").toLowerCase();
    const cat = this.catPub || "Todas";
    var agens = this.agents.filter(function(a) {
      if (!a.isPublic) return false;

      const okCat = cat === "Todas" ? true : (a.category || "") === cat;
      const text = (
        a.name +
        " " +
        a.description +
        " " +
        a.tags.join(" ")
      ).toLowerCase();

      const okQ = q.length === 0 ? true : text.indexOf(q) !== -1;

      return okCat && okQ;
    });
    return agens;
  }

  // acciones

  public cancelEdit(): void {
    this.current = null;
    this.editing = false;
  }

  public duplicateAgent(agent: ia_agent): void {
    ia_agents_store.duplicate(agent.id);
    this.syncFromStore();
  }

  public askDelete(agent: ia_agent): void {
    this.toDelete = agent;
    this.showConfirmDelete = true;
  }

  public confirmDelete(): void {
    if (this.toDelete) {
      ia_agents_store.remove(this.toDelete.id);
      this.toDelete = null;
      this.syncFromStore();
    }
    this.showConfirmDelete = false;
  }

  public useAgent(agent: ia_agent): void {
    // aplica al chat y vuelve al chat
    this.$emit("apply-agent", agent);

    this.$router.push({
      name: RouterNames.chatid,
      params: { id: "0" },
      query: agent ? { data: JSON.stringify(agent.id) } : {},
    });

    // this.close();
  }

  public close(): void {
    this.$router.push({ name: RouterNames.chatmain });
  }

  public selectorVisible: boolean = false;
  public editorVisible: boolean = false;
  public editingKind: "llm" | "http" | null = null;

  onNewAgent() {
    this.selectorVisible = true;
  }
  // Al pulsar "Nuevo agente"
  public startCreate(): void {
    // Muestra primero el selector de tipo
    this.selectorVisible = true;
    this.current = null;
    this.editingKind = null;
  }

  // Cuando se elige tipo
  public onTypeSelected(kind: "llm" | "http") {
    this.selectorVisible = false;
    this.editingKind = kind;
    this.editorVisible = true;
    this.current = null;
    this.editing=true;
  }

  // Al editar un agente existente:
  public editAgent(agent: ia_agent): void {
    this.current = agent;
    if (agent.kind === null || agent.kind === undefined) {
      agent.kind = "llm";
    }
    this.editingKind = agent.kind === "http" ? "http" : "llm";
    this.editorVisible = true;
    
    this.editing=true;
    console.log(this.editingKind, this.editorVisible);
  }

  public onCancelEditor(): void {
    this.editorVisible = false;
    this.editingKind = null;
    this.current = null;
  }

  // Guardar agente LLM
  public onSaveLLMAgent(model: ia_agent): void {
    model.kind = "llm";
    this.saveAgent(model);
  }

  // Guardar agente HTTP (usa el modelo generado por el HttpAgentEditorDialog)
  public onSaveHttpAgent(model: ia_agent): void {
    model.kind = "http";
    this.saveAgent(model);
  }

  // Guardado único integrado
  public saveAgent(model: ia_agent): void {
    if (model && model.id) {
      ia_agents_store.update(model.id, model);
    } else {
      ia_agents_store.create({
        name: model.name,
        description: model.description,
        category: model.category,
        icon: model.icon,
        tags: model.tags,
        systemPrompt: model.systemPrompt || "",
        isPublic: model.isPublic,
        empezar: model.empezar,
        kind: model.kind,
        http: (model as any).http,
      });
    }
    this.syncFromStore();
    this.onCancelEditor();
  }
}
